import React, { FC } from 'react';
import { Button, Skeleton, Space } from 'antd';
import { Image } from 'common/components';
import { ArrowRightLong } from 'common/svg';
import { ICategory } from 'entities/Category/Category.models';

interface IComponentProps {
  category: ICategory;
  goodsCount: number;
  loading?: boolean;
  onClick: (categoryId: number) => void;
}

const CatalogCategoryCardComponent: FC<IComponentProps> = ({ category, goodsCount, loading = false, onClick }) => {
  const changeCategory = (): void => {
    onClick(category.id);
  };

  if (loading) {
    return (
      <Button className="catalog-category-card">
        <Image size={80} />

        <Space className="catalog-category-card__skeleton-container">
          <Skeleton.Input className="catalog-category-card__skeleton-input" size="small" active />

          <Skeleton.Button size="small" active />
        </Space>
      </Button>
    );
  }

  return (
    <Button className="catalog-category-card" onClick={changeCategory}>
      <Image size={80} src={category.image} />

      <div className="flex-1">
        <div className="mb-3 ff-medium fs-m">{category.name}</div>
        <span className="ff-regular fs-xs color-dark-grey">{`${goodsCount} товаров`}</span>
      </div>

      <div className="catalog-category-card__hover">
        <span className="flex-1 ff-medium fs-m color-white">{category.name}</span>

        <div className="catalog-category-card__hover-arrow">
          <ArrowRightLong className="icon-arrow-right-long-white" />
        </div>
      </div>
    </Button>
  );
};

// memo: список перерисовывается при подгрузке счётчиков/скролле — карточки с неизменными пропсами не ререндерим.
export const CatalogCategoryCard = React.memo(CatalogCategoryCardComponent);
